<template>
  <RevSkeleton
    v-if="isDisplayPendingVerifiedRefurbishedCarousel"
    height="188px"
    shape="rectangle"
    width="100%"
  />
  <VerifiedRefurbishedCarousel
    v-else-if="
      shouldDisplayVerifiedRefurbishedCarousel &&
      productResponse &&
      verifiedRefurbishCarouselResponse
    "
    :category-id="productResponse.tracking.categoryId"
    :checkpoints="verifiedRefurbishCarouselResponse"
    :opened-index="stickerOpenedIndex"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RevSkeleton } from '@ds/components/Skeleton'

import VerifiedRefurbishedCarousel from '~/scopes/product-core/components/presentationals/VerifiedRefurbishedCarousel/VerifiedRefurbishedCarousel.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchVerifiedRefurbishCarousel } from '~/scopes/product-core/composables/useFetch/useFetchVerifiedRefurbishCarousel/useFetchVerifiedRefurbishCarousel'
import { useVerifiedRefurbishedCarousel } from '~/scopes/product-core/composables/useVerifiedRefurbishedCarousel/useVerifiedRefurbishedCarousel'

const { data: productResponse } = useFetchProduct()
const { data: verifiedRefurbishCarouselResponse } =
  useFetchVerifiedRefurbishCarousel()
const {
  shouldDisplayVerifiedRefurbishedCarousel,
  isDisplayPendingVerifiedRefurbishedCarousel,
} = useVerifiedRefurbishedCarousel()

const stickerOpenedIndex = computed(() => {
  const items = verifiedRefurbishCarouselResponse.value?.items ?? []
  const targetId =
    verifiedRefurbishCarouselResponse.value?.sticker?.targetVrCarouselItem
  if (!targetId) return 0
  const idx = items.findIndex((i) => i.id === targetId)
  return idx >= 0 ? idx : 0
})
</script>
